import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/rekam-medis",
    component: () => import("../views/RekamMedis/List.vue")
  },
  {
    path: "/rekam-medis/riwayat/:pasien_id",
    name: "riwayat-rekam-medis",
    props: true,
    component: () => import("../views/RiwayatRekamMedis.vue")
  },
  {
    path: "/rekam-medis/:transklinik_id/:pasien_id",
    name: "rekam-medis-pasien",
    component: () => import("../views/RekamMedis.vue")
  },
  {
    path: "/",
    name: "home",
    component: () => import("../views/Home.vue"),
    props: true,
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/About.vue")
  },
  {
    path: "/login",
    name: "login-page",
    component: () => import("../views/Login.vue"),
    meta: { layout: "examples" }
  },
  {
    path: "/idle",
    name: "idle-page",
    component: () => import("../views/Idle.vue"),
    meta: { layout: "examples" }
  },
  {
    path: "/sukses",
    name: "sukses-page",
    component: () => import("../views/HomePage.vue"),
    meta: { layout: "examples" }
  },
  {
    path: "/register",
    name: "register-page",
    component: () => import("../views/Register/RegisterKlinik.vue"),
    meta: { layout: "examples" }
  },
  // {
  //   path: "/register",
  //   name: "register-page",
  //   component: () => import("../views/Register/MenuRegister.vue"),
  //   meta: { layout: "examples" }
  // },
  // {
  //   path: "/register/dpm",
  //   name: "register-page-dpm",
  //   component: () => import("../views/Register.vue"),
  //   meta: { layout: "examples" }
  // },
  // {
  //   path: "/register/klinik",
  //   name: "register-page-klinik",
  //   component: () => import("../views/Register/RegisterKlinik.vue"),
  //   meta: { layout: "examples" }
  // },
  {
    path: "/verification/password/:token",
    name: "verification-password",
    component: () => import("../views/VerificationPassword.vue"),
    meta: { layout: "examples" }
  },
  {
    path: "/set-password/:token?",
    name: "set-password",
    component: () => import("../views/SetPassword/Layout.vue"),
    meta: { layout: "examples" },
    props: true
  },
  {
    path: "/expired-set-password",
    name: "expired-set-password",
    component: () => import("../views/SetPassword/Expired.vue"),
    meta: { layout: "examples" },
  },
  {
    path: "/replaced-set-password",
    name: "replaced-set-password",
    component: () => import("../views/SetPassword/Replaced.vue"),
    meta: { layout: "examples" },
  },
  {
    path: "/activated-set-password",
    name: "activated-set-password",
    component: () => import("../views/SetPassword/Activated.vue"),
    meta: { layout: "examples" },
  },
  {
    path: "/forgot-password/:token?",
    name: "forgot-password",
    component: () => import("../views/ForgotPassword.vue"),
    meta: { layout: "examples" },
    props: true
  },
  {
    path: "/forgot_password/invalid",
    name: "forgot-password-failed",
    component: () => import("../views/ForgotPassword/ForgotExpired.vue"),
    meta: { layout: "examples" },
  },
  {
    path: "/input-tarif",
    name: "input-tarif",
    component: () => import("../views/InputTarif.vue"),
    props: true
  },
  {
    path: "/input-data-operator",
    name: "input-data-operator",
    component: () => import("../views/InputDataOperator.vue")
  },
  {
    path: "/pilih-paket",
    name: "pilih-paket",
    component: () => import("../views/Subscription/PilihPaket.vue"),
  },
  {
    path: "/struk-subskripsi/:bill_id",
    name: "struk-subskripsi",
    component: () => import("../views/Subscription/StrukSubscription.vue"),
  },
  {
    path: "/init",
    component: () => import("../views/Initialization.vue"),
    children: [
      {
        path: "",
        name: "input-spesialisasi",
        component: () => import("../views/Initialization/InputSpesialisasi.vue"),
        props: true
      },
      {
        path: "input-asisten-dokter",
        name: "input-asisten-dokter",
        component: () =>
          import("../views/Initialization/InputDataAsistenDokter.vue"),
        props: true
      },
    ]
  },
  {
    path: "/init-klinik",
    meta: { layout: "examples" },
    component: () => import("../views/Initialization.vue"),
    children: [
      {
        path: "",
        name: "input-klinik",
        meta: { layout: "examples" },
        component: () => import("../views/Initialization/InputKlinik.vue"),
        props: true
      },
    ]
  },
  {
    path: "/verification",
    component: () => import("../views/Verification.vue"),
    children: [
      {
        path: "",
        name: "verification-process",
        component: () =>
          import("../views/Verification/VerificationProcess.vue"),
        meta: { layout: "examples" },
        props: true
      },
      {
        path: "login",
        name: "verification-login",
        component: () =>
          import("../views/Verification/VerificationLogin.vue"),
        meta: { layout: "examples" },
        props: true
      },
      {
        path: "operator/:token",
        name: "verification-operator",
        component: () =>
          import("../views/Verification/VerificationOperator.vue"),
        meta: { layout: "examples" },
        props: true
      },
      {
        path: ":state",
        name: "verification-result",
        component: () => import("../views/Verification/VerificationResult.vue"),
        meta: { layout: "examples" },
        props: true
      }
    ]
  },
  {
    path: "/rawat-jalan",
    component: () => import("../views/RawatJalan.vue"),
    children: [
      {
        path: "antrean",
        name: "antrean-rawat-jalan",
        component: () => import("../views/RawatJalan/Antrean.vue")
      },
      {
        path: "registrasi",
        name: "registrasi-rawat-jalan",
        component: () => import("../views/RawatJalan/Registrasi.vue")
      }
    ]
  },
  {
    path: "/pembayaran",
    component: () => import("../views/Pembayaran.vue"),
    children: [
      {
        path: ":bayar_id",
        // path: "tambah",
        name: "pembayaran-tambah",
        component: () => import("../views/Pembayaran/Tambah.vue")
      },
      {
        path: "",
        name: "pembayaran-list",
        component: () => import("../views/Pembayaran/List.vue")
      },
      {
        path: "struk/:pembayaran_id",
        name: "pembayaran-struk",
        component: () => import("../views/Pembayaran/StrukWrapper.vue")
      }
    ]
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("../views/Profile/Profile.vue")
  },
  {
    path: "/subskripsi/pilih-paket",
    name: "subskripsi-pilih-paket",
    component: () => import("../views/Billing/BillingPilihPaket.vue")
  },
  {
    path: "/subskripsi",
    name: "subskripsi",
    component: () => import("../views/Billing/List.vue")
  },
  {
    path: "/subskripsi/paket/:type",
    name: "subskripsi-paket",
    component: () => import("../views/Subscription/Paket.vue")
  },
  {
    path: "/subskripsi/detail/:id",
    name: "subskripsi-detail",
    component: () => import("../views/Subscription/DetailPaket.vue")
  },
  {
    path: "/subskripsi/addons",
    name: "subskripsi-addons",
    component: () => import("../views/Subscription/DetailAddons.vue")
  },
  {
    path: "/subskripsi/payment/:bill_id",
    name: "subskripsi-bayar",
    component: () => import("../views/Subscription/CaraPembayaran.vue")
  },
  {
    path: "/bayarind/:bill_id",
    name: "subskripsi-bayarind",
    component: () => import("../views/Subscription/StatusInvoice.vue")
  },
  {
    path: "/tarif",
    name: "tarif",
    component: () => import("../views/Tarif.vue"),
    children: [
      {
        path: "/tarif",
        name: "tarif-list",
        component: () => import("../views/Tarif/List.vue")
      },
      {
        path: "/tarif/tambah",
        name: "tarif-tambah",
        component: () => import("../views/Tarif/Tambah.vue")
      }
    ]
  },
  {
    path: "/laporan-pendapatan",
    name: "laporan-pendapatan",
    component: () => import("../views/LaporanPendapatanPage.vue")
  },
  {
    path: "/patient-engagement",
    name: "patient-engagement",
    component: () => import("../views/AddOns/PatientEngagement.vue")
  },

  // klinik,
  {
    path: "/klinik",
    component: () => import("../views/Klinik.vue"),
    children: [
      {
        path: "",
        name: "klinik-list",
        component: () => import("../views/Klinik/List.vue")
      },
      {
        path: "tambah",
        name: "klinik-tambah",
        component: () => import("../views/Klinik/Tambah.vue")
      },
      {
        path: "edit/:klinik_id",
        name: "klinik-edit",
        component: () => import("../views/Klinik/Edit.vue")
      }
    ]
  },

  //Change Klinik
  {
    path: "/change-klinik",
    name: "change-klinik",
    component: () => import("../views/UbahKlinik.vue"),
    meta: { layout: "examples" },
    props: true
  },

  //PIC Klinik
  {
    path: "/pic-klinik",
    component: () => import("../views/PICKlinik.vue"),
    children: [
      {
        path: "",
        name: "pic-klinik-list",
        component: () => import("../views/PICKlinik/List.vue")
      },
      {
        path: "tambah",
        name: "pic-klinik-tambah",
        component: () => import("../views/PICKlinik/Tambah.vue")
      },
      {
        path: "edit/:user_id/:klinik_id",
        name: "pic-klinik-edit",
        component: () => import("../views/PICKlinik/Edit.vue")
      }
    ]
  },
  {
    path: "/staff",
    component: () => import("../views/Staff.vue"),
    children: [
      {
        path: "",
        name: "staff-list",
        component: () => import("../views/Staff/List.vue")
      },
      {
        path: "tambah",
        name: "staff-tambah",
        component: () => import("../views/Staff/Tambah.vue")
      },
      {
        path: "edit/:user_id",
        name: "staff-edit",
        component: () => import("../views/Staff/Edit.vue")
      }
    ]
  },
  {
    path: "/manajemen",
    component: () => import("../views/Manajemen.vue"),
    children: [
      {
        path: "",
        name: "manajemen-list",
        component: () => import("../views/Manajemen/List.vue")
      },
      {
        path: "tambah",
        name: "manajemen-tambah",
        component: () => import("../views/Manajemen/Tambah.vue")
      },
      {
        path: "edit/:user_id",
        name: "manajemen-edit",
        component: () => import("../views/Manajemen/Edit.vue")
      }
    ]
  },
  {
    path: "/dokter",
    component: () => import("../views/Dokter.vue"),
    children: [
      {
        path: "",
        name: "dokter-list",
        component: () => import("../views/Dokter/List.vue")
      },
      {
        path: "tambah",
        name: "dokter-tambah",
        component: () => import("../views/Dokter/Tambah.vue")
      },
      {
        path: "edit/:user_id",
        name: "dokter-edit",
        component: () => import("../views/Dokter/Edit.vue")
      }
    ]
  },
  // Poliklinik
  {
    path: "/poliklinik",
    component: () => import("../views/Poliklinik.vue"),
    children: [
      {
        path: "",
        name: "poliklinik-list",
        component: () => import("../views/Poliklinik/List.vue")
      },
      {
        path: "tambah",
        name: "poliklinik-tambah",
        component: () => import("../views/Poliklinik/Tambah.vue")
      },
      {
        path: "edit/:id_poli",
        name: "poliklinik-edit",
        component: () => import("../views/Poliklinik/Tambah.vue"),
        props: true
      },
    ]
  },
  {
    path: "/role-manajemen",
    component: () => import("../views/RoleManajemen.vue"),
    children: [
      {
        path: "",
        name: "role-manajemen-list",
        component: () => import("../views/RoleManajemen/List.vue")
      }
    ]
  },
  {
    path: "/manajemen-tarif",
    component: () => import("../views/ManTarif.vue"),
    children: [
      {
        path: "",
        name: "manajemen-tarif-list",
        component: () => import("../views/ManajemenTarif/List.vue")
      },
      {
        path: "tambah",
        name: "manajemen-tarif-tambah",
        component: () => import("../views/ManajemenTarif/Tambah.vue")
      },
      {
        path: "upload",
        name: "upload-tarif",
        component: () => import("../views/ManajemenTarif/Upload.vue")
      },
      {
        path: "list-upload",
        name: "list-upload-tarif",
        component: () => import("../views/ManajemenTarif/ListUpload.vue")
      }
    ]
  },
  // Pasien Klinik
  {
    path: "/pasien-klinik",
    component: () => import("../views/Pasien.vue"),
    children: [
      {
        path: "",
        name: "pasien-klinik-list",
        component: () => import("../views/PasienKlinik/List.vue")
      },
      {
        path: "tambah",
        name: "pasien-klinik-tambah",
        component: () => import("../views/PasienKlinik/Tambah.vue")
      },
      {
        path: "edit/:idPasien",
        name: "pasien-klinik-edit",
        component: () => import("../views/PasienKlinik/Edit.vue")
      },
      {
        path: "detail/:idPasien",
        name: "pasien-klinik-detail",
        component: () => import("../views/PasienKlinik/Detail.vue"),
        props: true
      },
      {
        path: "kartu/:id",
        name: "kartu-pasien-klinik",
        component: () => import("../views/PasienKlinik/KartuPasien.vue")
      },
      {
        path: "upload",
        name: "upload-pasien-klinik",
        component: () => import("../views/PasienKlinik/Upload.vue")
      },
      {
        path: "list-upload",
        name: "list-upload-pasien-klinik",
        component: () => import("../views/PasienKlinik/ListUpload.vue")
      }
    ]
  },
  // Klinik Antrean
  {
    path: "/antrean-klinik",
    component: () => import("../views/AntreanKlinik.vue"),
    children: [
      {
        path: "",
        name: "antrean-klinik-list",
        component: () => import("../views/KlinikAntrean/List.vue")
      },
      {
        path: "bridge",
        name: "antrean-klinik-brigde",
        component: () => import("../views/KlinikAntrean/Bridge.vue")
      },
      {
        path: "tambah",
        name: "antrean-klinik-tambah",
        component: () => import("../views/KlinikAntrean/Tambah.vue")
      },
      {
        path: "edit/:id",
        name: "antrean-klinik-edit",
        component: () => import("../views/KlinikAntrean/Tambah.vue"),

      },
    ],
  },
  // Rekam Medis Klinik
  {
    path: "/klinik/rekam-medis",
    component: () => import("../views/RM_Klinik/List.vue")
  },
  {
    path: "/klinik/rekam-medis/riwayat/:pasien_id",
    name: "klinik-riwayat-rekam-medis",
    props: true,
    component: () => import("../views/RM_Klinik/Riwayat.vue")
  },
  {
    path: "/klinik/rekam-medis/:transklinik_id/:pasien_id",
    name: "klinik-rekam-medis-pasien",
    component: () => import("../views/RM_Klinik/RekamMedis.vue")
  },

  // Manajemen BHP
  {
    path: "/klinik/bhp",
    name: "klinik-list-bhp",
    component: () => import("../views/Bhp/List.vue")
  },
  {
    path: "/klinik/bhp/tambah",
    name: "klinik-tambah-bhp",
    component: () => import("../views/Bhp/Form.vue")
  },
  {
    path: "/klinik/bhp/edit/:id",
    name: "klinik-edit-bhp",
    component: () => import("../views/Bhp/Form.vue")
  },
  {
    path: "/klinik/bhp/upload",
    name: "klinik-bhp-upload",
    component: () => import("../views/Bhp/Upload.vue")
  },
  {
    path: "/klinik/bhp/list-upload",
    name: "klinik-bhp-list-upload",
    component: () => import("../views/Bhp/ListUpload.vue")
  },
  // Obat Klinik
  {
    path: "/klinik/obat",
    name: "klinik-obat-list",
    component: () => import("../views/ObatKlinik/List.vue")
  },
  {
    path: "/klinik/obat/tambah",
    name: "klinik-obat-tambah",
    component: () => import("../views/ObatKlinik/Tambah.vue")
  },
  {
    path: "/klinik/obat/:id",
    name: "klinik-obat-edit",
    component: () => import("../views/ObatKlinik/Edit.vue")
  },
  {
    path: "/klinik/obat/upload",
    name: "klinik-obat-upload",
    component: () => import("../views/ObatKlinik/Upload.vue")
  },
  {
    path: "/klinik/obat/list-upload",
    name: "klinik-obat-list-upload",
    component: () => import("../views/ObatKlinik/ListUpload.vue")
  },
  // Manajemen stok obat & bhp
  {
    path: "/klinik/stok",
    component: () => import("../views/StockManagement.vue"),
    children: [
      {
        path: "obat",
        name: "klinik-stok-obat",
        component: () => import("../views/StokKlinik/Obat.vue")
      },
      {
        path: "obat/upload",
        name: "klinik-stok-obat-upload",
        component: () => import("../views/StokKlinik/ObatUpload.vue")
      },
      {
        path: "obat/list-upload",
        name: "klinik-stok-obat-list-upload",
        component: () => import("../views/StokKlinik/ObatListUpload.vue")
      },
      {
        path: "obat/tambah",
        name: "klinik-stok-obat-tambah",
        component: () => import("../views/StokKlinik/ObatForm.vue")
      },
      {
        path: "obat/edit/:id",
        name: "klinik-stok-obat-edit",
        component: () => import("../views/StokKlinik/ObatFormEdit.vue")
      },
      {
        path: "bhp",
        name: "klinik-stok-bhp",
        component: () => import("../views/StokKlinik/Bhp.vue")
      },
      {
        path: "bhp/tambah",
        name: "klinik-stok-bhp-tambah",
        component: () => import("../views/StokKlinik/BhpForm.vue")
      },
      {
        path: "bhp/edit/:id",
        name: "klinik-stok-bhp-edit",
        component: () => import("../views/StokKlinik/BhpFormEdit.vue")
      },
      {
        path: "bhp/upload",
        name: "klinik-stok-bhp-upload",
        component: () => import("../views/StokKlinik/UploadBhp.vue")
      },
      {
        path: "bhp/list-stok-upload",
        name: "klinik-stok-bhp-list-upload",
        component: () => import("../views/StokKlinik/ListUpload.vue")
      },
      {
        path: "report",
        name: "klinik-stok-report",
        component: () => import("../views/StokKlinik/Report.vue")
      },
      {
        path: "report/:id/stock",
        name: "klinik-stock-report-detail",
        component: () => import("../views/StokKlinik/ReportDetail/DetailStock.vue")
      },
      {
        path: "report/:id/sell-stock",
        name: "klinik-sell-stock-report-detail",
        component: () => import("../views/StokKlinik/ReportDetail/DetailSellStock.vue")
      }
    ]
  },
  // Account Setting
  {
    path: "/account-setting/klinik",
    name: "account-setting",
    // component: () => import("../views/AccountSettingKlinik/Detail.vue")
    component: () => import("../views/AccountSettingKlinik/WrapperProfile.vue")
  },
  {
    path: "/account-setting/jadwal_dan_fasilitas",
    name: "account-setting-fasilitas",
    component: () => import("../views/AccountSettingKlinik/Fasilitas.vue")
  },
  {
    path: "/account-setting/profile",
    name: "account-setting-profile",
    component: () => import("../views/AccountSettingKlinik/DataProfile.vue")
  },
  {
    path: "/account-setting/skema-komisi",
    name: "account-setting-skema-komisi",
    component: () => import("../views/AccountSettingKlinik/SkemaKomisi.vue")
  },
  {
    path: "/account-setting/bridging-bpjs",
    name: "account-setting-bridging-bpjs",
    component: () => import("../views/AccountSettingKlinik/BridgingBPJS.vue")
  },
  {
    path: "/account-setting/bridging-satu-sehat",
    name: "account-setting-bridging-satu-sehat",
    component: () => import("../views/AccountSettingKlinik/BridgingSatuSehat.vue")
  },
  {
    path: "/account-setting/setting-location",
    name: "account-setting-setting-location",
    component: () => import("../views/AccountSettingKlinik/SettingLocation.vue")
  },
  {
    path: "/account-setting/verification-code",
    name: "account-setting-verification-code",
    meta: { layout: "examples" },
    component: () => import("../views/AccountSettingKlinik/VerificationCode.vue")
  },

  // account setting - PIC
  {
    path: "/account-setting/faskes-profile",
    name: "account-setting-faskes-profile",
    // component: () => import("../views/AccountSettingKlinik/Detail.vue")
    component: () => import("../views/AccountSettingKlinik/Pic/FaskesProfile.vue")
  },
  {
    path: "/account-setting/faskes-setting",
    name: "account-setting-faskes-setting",
    // component: () => import("../views/AccountSettingKlinik/Detail.vue")
    component: () => import("../views/AccountSettingKlinik/Pic/FaskesSetting.vue")
  },

  // Klinik Pembayaran
  {
    path: "/klinik/pembayaran",
    component: () => import("../views/Pembayaran.vue"),
    children: [
      {
        path: "/",
        name: "klinik-pembayaran-list",
        component: () => import("../views/PembayaranKlinik/List.vue")
      },
      {
        path: ":bayar_id",
        name: "klinik-pembayaran-tambah",
        component: () => import("../views/PembayaranKlinik/Tambah.vue")
      },
      {
        path: "struk/:pembayaran_id",
        name: "klinik-pembayaran-struk",
        component: () => import("../views/PembayaranKlinik/Struk.vue")
      }
    ]
  },
  // Klinik Subscription
  {
    path: "/klinik/subskripsi",
    name: "subskripsi-klinik",
    component: () => import("../views/BillingKlinik/List.vue")
  },
  {
    path: "/klinik/subskripsi/pilih-paket",
    name: "subskripsi-pilih-paket-klinik",
    component: () => import("../views/BillingKlinik/BillingPilihPaket.vue")
  },
  {
    path: "/klinik/subskripsi/paket/:type",
    name: "subskripsi-paket-klinik",
    component: () => import("../views/SubscriptionKlinik/Paket.vue")
  },
  {
    path: "/klinik/subskripsi/payment/:bill_id",
    name: "subskripsi-bayar-klinik",
    component: () => import("../views/SubscriptionKlinik/CaraPembayaran.vue")
  },
  {
    path: "/klinik/struk-subskripsi/:bill_id",
    name: "struk-subskripsi-klinik",
    component: () => import("../views/SubscriptionKlinik/StrukSubscription.vue"),
  },

  {
    path: "/klinik/bayarind/:bill_id",
    name: "subskripsi-bayarind-klinik",
    component: () => import("../views/SubscriptionKlinik/StatusInvoice.vue")
  },

  // Klinik Survey
  {
    path: "/klinik/komisi",
    component: () => import("../views/KomisiKlinik.vue"),
    children: [
      {
        path: "/",
        name: "klinik-komisi-list",
        component: () => import("../views/KomisiKlinik/List.vue")
      },
      {
        path: "tambah",
        name: "klinik-komisi-tambah",
        component: () => import("../views/KomisiKlinik/Tambah.vue")
      },
      {
        path: "edit/:idComition",
        name: "klinik-komisi-edit",
        component: () => import("../views/KomisiKlinik/Tambah.vue")
      },
      {
        path: "report",
        name: "klinik-komisi-report",
        component: () => import("../views/KomisiKlinik/Report.vue")
      },
      {
        path: "report/:user_id/:role_id?",
        name: "klinik-report-detail",
        component: () => import("../views/KomisiKlinik/ReportDetail.vue")
      },
    ]
  },
  //Halaman Survey
  {
    path: "/survey",
    name: "survey",
    meta: { layout: "examples" },
    component: () => import("../views/Initialization/Survey.vue")
  },
  {
    path: "/reset",
    name: "reset",
    component: () => import("../views/Reset.vue")
  },
  {
    path: "/subskripsi-info",
    name: "subskripsi-info",
    component: () => import("../views/SubskripsiInfo.vue")
  },

  //Farmasi
  {
    path: "/klinik/farmasi",
    component: () => import("../views/Farmasi.vue"),
    children: [
      {
        path: "",
        name: "farmasi-list",
        component: () => import("../views/Farmasi/List.vue")
      },
      {
        path: ":id",
        name: "farmasi-detail",
        component: () => import("../views/Farmasi/Detail.vue")
      },
    ]
  },
  //Penjualan
  {
    path: "/klinik/penjualan",
    component: () => import("../views/Penjualan.vue"),
    children: [
      {
        path: "",
        name: "penjualan-list",
        component: () => import("../views/Penjualan/List.vue")
      },
      {
        path: "tambah",
        name: "penjualan-tambah",
        component: () => import("../views/Penjualan/Add.vue")
      },
      {
        path: "tambah/:id",
        name: "penjualan-tambah-save",
        component: () => import("../views/Penjualan/Add.vue")
      },
      {
        path: "struk/:id",
        name: "penjualan-struk",
        component: () => import("../views/Penjualan/Struk.vue")
      }
    ]
  }
];


const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return window.scrollTo({ top: 0, behavior: "smooth" });
  },
  routes
});

router.beforeEach((to, from, next) => {
  const { name } = to;

  // Exclude Idle
  // const excludeIdle = [
  //   'rekam-medis-pasien', 'pasien-edit', 'pasien-tambah',
  //   'pembayaran-tambah', 'profile', 'registrasi-rawat-jalan',
  //   'tarif-tambah', 'idle-page', 'login-page', 'register-page',
  //   'register-page-dpm', 'register-page-klinik', 'sukses-page',
  //   'forgot-password', 'forgot-password-failed', 'input-tarif',
  //   'input-data-operator', 'pilih-paket', 'initialization',
  //   'input-spesialisasi', 'input-asisten-dokter','initialization-klinik','input_klinik',
  // ].includes(name);

  // if(excludeIdle) {
  localStorage.setItem('PREVENT_IDLE', 1);
  // }
  // else {
  //   localStorage.setItem('PREVENT_IDLE', 0);
  // }

  const isAuthenticated = store.state.BEARER_TOKEN !== null;
  const isRouteAuth = [
    "login-page",
    "idle-page",
    "register-page",
    "forgot-password",
    "verification-process",
    "verification-operator",
    "verification-result",
    "verification-login",
    "forgot-password-failed",
    "sukses-page",
    "register-page-dpm",
    "register-page-klinik",
    "verification-password",
    "reset",
    'set-password',
    'expired-set-password',
    'replaced-set-password',
    'activated-set-password',
  ].includes(name);

  if (!isAuthenticated && !isRouteAuth) next("/login");
  else if (isAuthenticated && isRouteAuth) next("/");
  else next();
});

export default router;
